import { SearchWithFilter } from 'components/search'

const ProvematerialePage = () => {
	return <SearchWithFilter />
}

export default ProvematerialePage
